import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthService from "services/authService";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Confirmation() {
  const [status, setStatus] = useState("pending"); // pending, success, error
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const query = useQuery();

  useEffect(() => {
    const token = query.get("token");
    if (!token) {
      setStatus("error");
      setMessage("No verification token provided.");
      return;
    }
  
    const verify = async () => {
      try {
        const response = await AuthService.confirmLogin(token);
        setStatus("success");
        const { access_token } = response;

        setMessage("Verification successful! You will be redirected to the dashboard.");
        // Store the access token if present
        if (access_token) {
          // Choose localStorage or sessionStorage as per your logic
          localStorage.setItem("access_token", access_token);
        }
  
        // Auto-redirect after a delay:
        setTimeout(() => navigate("/api/v1/dashboard"), 2000);
      } catch (err) {
        setStatus("error");
        setMessage(
          err.response?.data?.detail ||
            "Verification failed. The link may be invalid or expired."
        );
      }
    };
  
    verify();
  }, [query, navigate]);

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor={status === "success" ? "success" : "error"}
          borderRadius="lg"
          coloredShadow={status === "success" ? "success" : "error"}
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {status === "pending"
              ? "Verifying..."
              : status === "success"
              ? "Verification Successful"
              : "Verification Failed"}
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3} textAlign="center">
          <MDTypography color={status === "success" ? "success" : "error"}>
            {message}
          </MDTypography>
          {status === "error" && (
            <MDBox mt={2}>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => navigate("/api/v1/authentication/sign-in")}
              >
                Back to Sign In
              </MDButton>
            </MDBox>
          )}
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Confirmation;